import { AtLeastOne } from "@/interfaces/genericTypes.types"
import { SelfType } from "@/interfaces/self_types"

type EditSelf_EditableKeys = 'preferred_lang' | 'accepted_news' | 'username' | 'email' | 'phone' | 'password' | 'ctry_code'
type EditableBase = Pick<SelfType, EditSelf_EditableKeys>
export type EditSelfPayload = AtLeastOne<EditableBase, EditSelf_EditableKeys>
export type EditSelfData = {
  id?: string
  time: string
  client_id: string
  data: EditSelfPayload
}

export enum DeleteUserErrorsTypes {
  UNAUTHENTICATED = 401,
  UNAUTHORIZED = 403
}